import { BaseContainerModel } from '../../../base-container.model';
import {
    bl_alg_cc_queue_rule_link_RowClass,
    bl_alg_cc_queue_rule_link_RowInterface,
} from '../../../../dbschema';

export class TaskRouterQueueRuleLinkContainerModel extends BaseContainerModel {
    bl_alg_cc_queue_rule_link: bl_alg_cc_queue_rule_link_RowInterface =
    new bl_alg_cc_queue_rule_link_RowClass;
}
